"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function err(error) { return { success: false, error }; }
exports.err = err;
function ok(value) { return { success: true, value }; }
exports.ok = ok;
//# sourceMappingURL=result.js.map